import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QuickAccessList } from "../../Types/Home/QuickAccessList";
import { getAllQuickAccessData } from "../../Thunks/QuickAccessThunks";

interface QuickAccessSliceState {
    loader: boolean; // for refres pages and inital loadings
    quickAccessList: QuickAccessList[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : QuickAccessSliceState = {
    loader: false,
    quickAccessList: [],
    errorDisplay: '',

}

// set state valu for api response
const quickAccessSlice = createSlice ({
    name: 'quickAccess',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllQuickAccessData.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllQuickAccessData.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllQuickAccessData.fulfilled, (state, action: PayloadAction<QuickAccessList[]>) => {
                    state.loader = false;
                    state.quickAccessList = action.payload;
                  })
    }
})

export const {} = quickAccessSlice.actions
export default quickAccessSlice.reducer
